app.controller('popupLaboratoryTestResultUpdateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel',
            'applicationModel', 'visitModel', 'userModel', 'patientModel', 'laboratoryTestResultModel', 'laboratoryResultToUpdate',
            'fileUploadModel', 'attachmentFileModel', 'preview',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel,
              laboratoryTestResultModel, laboratoryResultToUpdate, fileUploadModel, attachmentFileModel, preview) {

        function checkAllFilesLoaded() {
            function check(element) {
                return (element.loaded == true);
            }

            return $scope.fileList.every(check);
        }

        function saveLaboratoryTestResult () {
            laboratoryTestResultModel.update($scope.laboratoryResult);

            var successWatcherDisabler = $scope.$on(Event.LABORATORY_TEST_RESULT.UPDATE.SUCCESS, function (event, result) {
                successWatcherDisabler();
                errorWatcherDisabler();
                $scope.actionInProgress = false;
                $mdDialog.hide();
            });
            var errorWatcherDisabler = $scope.$on(Event.LABORATORY_TEST_RESULT.UPDATE.ERROR, function (event, error) {
                successWatcherDisabler();
                errorWatcherDisabler();
                $scope.actionInProgress = false;
            });
        }

        function setData() {
            $scope.laboratoryResult = angular.copy(laboratoryResultToUpdate);
            $scope.laboratoryResult.patient = new PatientVO();
            $scope.laboratoryResult.patient.id = $state.params.patientId;

            $scope.fileList = [];

            if($scope.laboratoryResult.attachments.length) {
                $scope.laboratoryResult.attachments.forEach(function (attachmentFile) {
                    $scope.fileList.push({
                        loaded: true,
                        data: null,
                        attachmentFile: attachmentFile.attachmentFiles[0],
                        name: attachmentFile.name
                    });
                });
            }

            $scope.forms = {
                laboratoryResultForm: null
            };

            $scope.laboratoryResultActionType = 'update';

            $scope.previewOnly = preview || ($scope.laboratoryResult.author.userType === 'DOCTOR' && $scope.laboratoryResult.author.id != userModel.currentUser.id);

            if($scope.laboratoryResult.needsAnalysis) {
                $scope.previewOnly = false;
            }
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {

            $scope.save = function () {

                $scope.forms.laboratoryResultForm.$setSubmitted();
                if ($scope.forms.laboratoryResultForm.$valid) {

                    $scope.actionInProgress = true;

                    $scope.fileList.forEach(function (file) {
                        if(!file.attachmentFile) {
                            fileUploadModel.uploadFile(file);
                        }
                    });

                    if(checkAllFilesLoaded()) {
                        saveLaboratoryTestResult();
                    }

                    $scope.$on(Event.FILE_UPLOAD.UPLOAD_FILE.SUCCESS, function (event, attachmentFile, file) {
                        file.loaded = true;

                        var attachment = new AttachmentVO();

                        if(!attachment.attachmentFiles) {
                            attachment.attachmentFiles = [];
                        }
                        attachment.name = attachmentFile.fileName;
                        attachment.attachmentFiles.push(attachmentFile);

                        $scope.laboratoryResult.attachments.push(attachment);

                        if(checkAllFilesLoaded()) {
                            saveLaboratoryTestResult();
                        }

                    });

                }
            };

            $scope.enclose = function (fileInput) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function(element) {
                        $scope.fileList.push({ loaded: false, data: element })
                    });
                }
            };

            $scope.deleteLaboratoryTestResultAttachment = function(fileToDelete) {
                if(fileToDelete.attachmentFile) {
                    _.remove($scope.laboratoryResult.attachments, function (attachmentFile) {
                        return attachmentFile.attachmentFiles[0] === fileToDelete.attachmentFile;
                    })
                }
                _.remove($scope.fileList, function (file) {
                    return file === fileToDelete;
                })
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.downloadAttachmentFile = function(attachmentId) {
                attachmentFileModel.download(attachmentId)
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);